export default function checkMoreInfantsThanAdults(childrenAges, numberOfAdults, value = 0) {
  const numberOfInfants = childrenAges && childrenAges.filter((age) => age < 2).length;
  return numberOfInfants + value > numberOfAdults;
}